import React, { useState } from 'react';
import { Container, Tab, Tabs, Table, Badge, Button } from 'react-bootstrap';
import { FaEdit, FaTrash, FaEye } from 'react-icons/fa';
import './PropertiesManagement.scss';

const PropertiesManagement = () => {
  const [key, setKey] = useState('available');

  // Dummy data - replace with actual data from your backend
  const availableProperties = [
    {
      id: 1,
      title: 'Modern Apartment',
      price: '$250,000',
      location: 'Downtown',
      type: 'Apartment',
      bedrooms: 2,
      status: 'Available'
    },
    {
      id: 2,
      title: 'Beach House Villa',
      price: '$500,000',
      location: 'Beachfront',
      type: 'Villa',
      bedrooms: 4,
      status: 'Available'
    }
  ];

  const soldProperties = [
    {
      id: 3,
      title: 'Luxury Penthouse',
      price: '$750,000',
      location: 'City Center',
      type: 'Penthouse',
      bedrooms: 3,
      soldDate: '2025-03-15',
      soldPrice: '$745,000'
    }
  ];

  const renderPropertyTable = (properties, isSold = false) => (
    <Table responsive striped hover className="property-table">
      <thead>
        <tr>
          <th>Title</th>
          <th>Price</th>
          <th>Location</th>
          <th>Type</th>
          <th>Bedrooms</th>
          {isSold && (
            <>
              <th>Sold Date</th>
              <th>Sold Price</th>
            </>
          )}
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {properties.map((property) => (
          <tr key={property.id}>
            <td>{property.title}</td>
            <td>{property.price}</td>
            <td>{property.location}</td>
            <td>{property.type}</td>
            <td>{property.bedrooms}</td>
            {isSold && (
              <>
                <td>{property.soldDate}</td>
                <td>{property.soldPrice}</td>
              </>
            )}
            <td>
              <div className="action-buttons">
                <Button variant="info" size="sm" className="me-2">
                  <FaEye />
                </Button>
                <Button variant="primary" size="sm" className="me-2">
                  <FaEdit />
                </Button>
                <Button variant="danger" size="sm">
                  <FaTrash />
                </Button>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );

  return (
    <Container fluid className="properties-management py-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Properties Management</h2>
        <Button variant="success">Add New Property</Button>
      </div>

      <Tabs
        id="properties-tabs"
        activeKey={key}
        onSelect={(k) => setKey(k)}
        className="mb-4"
      >
        <Tab eventKey="available" title="Available Properties">
          {renderPropertyTable(availableProperties)}
        </Tab>
        <Tab eventKey="sold" title="Sold Properties">
          {renderPropertyTable(soldProperties, true)}
        </Tab>
      </Tabs>
    </Container>
  );
};

export default PropertiesManagement;
